module.exports = __webpack_public_path__ + "img/lead_slide5.91fb6422.png";